import { render } from "./component-change-status.vue?vue&type=template&id=7736720b"
import script from "./component-change-status.vue?vue&type=script&setup=true&lang=js"
export * from "./component-change-status.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-change-status.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7736720b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7736720b', __exports__)) {
    api.reload('7736720b', __exports__)
  }
  
  module.hot.accept("./component-change-status.vue?vue&type=template&id=7736720b", () => {
    api.rerender('7736720b', render)
  })

}


export default __exports__